import { BALLOON, FINANCE } from '@makemydeal/dr-platform-types';
import { dealerSelectors } from '@makemydeal/dr-shared-store';
import type { AnyAction, Dispatch } from 'redux';
import * as offerReduxSelectors from '../selectors/offerRedux';
import { updatedOfferType } from './offerRedux';
import { thunkUpdateOfferTypeToFlexBuy } from './flexBuyActionCreators';
import {
    DEAL_TYPE_OVERRIDDEN,
    FEES_ACCORDION_TOGGLE,
    LIENHOLDER_ACCORDION_TOGGLE,
    PAYMENT_DETAILS_ACCORDION_TOGGLE,
    TAXES_ACCORDION_TOGGLE
} from '../actionTypes/deskingGlobalActionTypes';

export const togglePaymentDetailsAccordion = () => {
    return {
        type: PAYMENT_DETAILS_ACCORDION_TOGGLE
    };
};

export const toggleTaxesAccordion = () => {
    return {
        type: TAXES_ACCORDION_TOGGLE
    };
};

export const toggleFeesAccordion = () => {
    return {
        type: FEES_ACCORDION_TOGGLE
    };
};

export const toggleLienholderAccordion = () => {
    return {
        type: LIENHOLDER_ACCORDION_TOGGLE
    };
};

export const thunkOverrideUnsupportedDealType = () => (dispatch: Dispatch<AnyAction, any>, getState: any) => {
    const state = getState();
    const currentOfferType = offerReduxSelectors.getCurrentOfferType(state);
    const isBalloonEnabled = dealerSelectors.isBalloonDealTypeEnabledForDealer(state);
    const isFlexBuyEnabled = dealerSelectors.dealerFlexBuyEnabled(state);
    const isFlexBuy = offerReduxSelectors.isFlexBuyPayment(state);

    let overriddenDealTypeLabel: string | null = null;
    if (currentOfferType === BALLOON && !isBalloonEnabled) {
        dispatch(updatedOfferType(FINANCE));
        overriddenDealTypeLabel = 'Balloon';
    } else if (isFlexBuy && !isFlexBuyEnabled) {
        dispatch(
            thunkUpdateOfferTypeToFlexBuy({
                shouldAddFlexBuy: false,
                shouldRemoveFlexBuy: true,
                defaultFordFlexBuy: 0
            }) as any
        );
        overriddenDealTypeLabel = 'Flex Buy';
    }

    if (overriddenDealTypeLabel) {
        dispatch({
            type: DEAL_TYPE_OVERRIDDEN,
            payload: `Deal type changed to Finance. This deal was written as ${overriddenDealTypeLabel}, which isn't enabled in your DR Admin settings. Review the terms before submitting.`
        });
    }
};
